export default {
    SBD: {
        shortDescription: 'Where Exclusive is Always Inclusive',
    },
    SLS: {
        shortDescription: 'Beyond the unexpected.',
    },
    SLU: {
        shortDescription: 'Glamorous resort with a cove beach and cliff-side suites.',
    },
    SMB: {
        shortDescription: "A fun-filled holiday on Jamaica's best private beach.",
    },
    SEB: {
        shortDescription: 'A privileged escape within the seclusion of the Exumas.',
    },
    SRC: {
        shortDescription: 'A British Colonial estate with an exotic offshore island.',
    },
    SNG: {
        shortDescription: "The ultimate laid-back resort on Jamaica's most famous beach.",
    },
    SGO: {
        shortDescription: 'Two distinct resort experiences surrounded by natural Jamaica.',
    },
    SWH: {
        shortDescription: 'An all-beachfront oasis amidst a 500-acre nature preserve.',
    },
    BRP: {
        shortDescription: "All-butler, all-oceanview boutique resort on Jamaica's Riviera.",
    },
    SAT: {
        shortDescription: "Two distinct resort experiences on Antigua's best beach.",
    },
    SHC: {
        shortDescription: 'The quintessential Caribbean resort amidst luxuriant gardens.',
    },
    SGL: {
        shortDescription: 'Views that stir the soul from a unique peninsula location.',
    },
    SRB: {
        shortDescription: 'A sophisticated European resort with its own offshore island.',
    },
    INN: {
        shortDescription: 'An intimate beachside Inn with 24-hour room service.',
    },
    BBO: {
        shortDescription: 'VOTED top 5 caribbean resort for families by TripAdvisor<sup>&reg;</sup> Reviewers.',
    },
    BNG: {
        shortDescription: 'VOTED ##1 caribbean resort for families by TripAdvisor<sup>&reg;</sup> Reviewers.',
    },
    SBR: {
        shortDescription: 'Experience the New Vision of Luxury Included',
    }
};
